(() => {
  if (window.__acCartGuard) return;
  window.__acCartGuard = true;
  const nativeFetch = window.fetch.bind(window);
  const addRequests = new Map();
  let pending = 0;
  let intentPending = false;
  let intentTimer;
  let unlockTimer;
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const markBusy = (busy) => {
    if (busy) document.documentElement.dataset.acCartBusy = 'true';
    else delete document.documentElement.dataset.acCartBusy;
    document.querySelectorAll('cart-items,cart-drawer-items').forEach((element) => element.setAttribute('aria-busy', String(busy)));
  };
  const begin = () => {
    clearTimeout(unlockTimer);
    clearTimeout(intentTimer);
    intentPending = false;
    pending += 1;
    markBusy(true);
  };
  const end = () => {
    pending = Math.max(0, pending - 1);
    if (pending) return;
    const release = () => { if (!pending) markBusy(false); };
    requestAnimationFrame(() => requestAnimationFrame(release));
    unlockTimer = setTimeout(release, 400);
  };
  const classify = (input, init) => {
    try {
      const address = new URL(typeof input === 'string' ? input : input.url, window.location.origin);
      const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (address.origin !== window.location.origin || method !== 'POST') return '';
      const match = address.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/);
      return match ? match[1] : '';
    } catch (_) { return ''; }
  };
  const bodyObject = (body) => {
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) {
        try { return Object.fromEntries(new URLSearchParams(body)); } catch (_) { return null; }
      }
    }
    if (body instanceof FormData || body instanceof URLSearchParams) return Object.fromEntries(body.entries());
    return null;
  };
  const addFingerprint = (body) => {
    const data = bodyObject(body);
    if (!data) return '';
    if (Array.isArray(data.items)) return JSON.stringify(data.items.map((item) => ({
      id: String(item.id), quantity: Number(item.quantity || 1),
      properties: item.properties || {}, selling_plan: item.selling_plan || ''
    })));
    const items = [];
    Object.keys(data).forEach((key) => {
      const match = key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/);
      if (match) {
        const index = Number(match[1]);
        items[index] = items[index] || {};
        items[index][match[2]] = String(data[key]);
      }
    });
    if (items.length) return JSON.stringify({ items, properties: Object.entries(data).filter(([key]) => key.includes('[properties]')) });
    if (data.id) return JSON.stringify({
      id: String(data.id), quantity: String(data.quantity || 1), selling_plan: data.selling_plan || '',
      properties: Object.entries(data).filter(([key]) => key.startsWith('properties[')).sort()
    });
    return '';
  };
  const withLineKey = (init) => {
    if (!init) return init;
    const data = bodyObject(init.body);
    const line = data && Number(data.line);
    if (!Number.isInteger(line) || line < 1) return init;
    const drawerOpen = document.querySelector('cart-drawer.active');
    const selector = '[data-index="' + line + '"][data-cart-key]';
    const element = (drawerOpen && drawerOpen.querySelector(selector)) ||
      document.querySelector('#main-cart-items ' + selector) ||
      document.querySelector('#CartDrawer ' + selector);
    if (!element || !element.dataset.cartKey) return init;
    data.id = element.dataset.cartKey;
    delete data.line;
    const headers = new Headers(init.headers || {});
    headers.set('Content-Type', 'application/json');
    return { ...init, headers, body: JSON.stringify(data) };
  };
  const dropLonelyProtection = (cart) => {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
    if (!cart.items.every((item) => item && item.handle === 'shipping-protection')) return;
    nativeFetch(root() + 'cart/clear.js', { method: 'POST' }).then(() => window.location.reload()).catch(() => {});
  };
  window.fetch = function (input, init) {
    const kind = classify(input, init);
    if (!kind) return nativeFetch(input, init);
    const fingerprint = kind === 'add' ? addFingerprint(init && init.body) : '';
    const previous = fingerprint && addRequests.get(fingerprint);
    if (previous && (previous.inFlight || Date.now() - previous.finishedAt < 900)) {
      return previous.promise.then((response) => response.clone());
    }
    const options = kind === 'change' ? withLineKey(init) : init;
    begin();
    const record = { inFlight: true, finishedAt: 0, promise: null };
    const promise = nativeFetch(input, options).then(async (response) => {
      const cart = await response.clone().json().catch(() => null);
      record.inFlight = false;
      record.finishedAt = Date.now();
      if (!response.ok && fingerprint) addRequests.delete(fingerprint);
      if (kind === 'change' || kind === 'update') {
        dropLonelyProtection(cart);
      }
      return response;
    }).catch((error) => {
      if (fingerprint) addRequests.delete(fingerprint);
      throw error;
    }).finally(end);
    record.promise = promise;
    if (fingerprint) {
      addRequests.set(fingerprint, record);
      promise.finally(() => setTimeout(() => {
        if (addRequests.get(fingerprint) === record) addRequests.delete(fingerprint);
      }, 1100)).catch(() => {});
    }
    return promise.then((response) => response.clone());
  };
  window.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest(
      '#CartDrawer .quantity__button,#CartDrawer cart-remove-button,#CartDrawer [name="checkout"],' +
      '#main-cart-items .quantity__button,#main-cart-items cart-remove-button,#checkout,' +
      'form[action*="/cart/add"] [type="submit"],[data-buy-now],sticky-atc .button'
    );
    if (!control) return;
    if (!pending && !intentPending) {
      if (control.closest('#CartDrawer,#main-cart-items')) {
        intentPending = true;
        markBusy(true);
        intentTimer = setTimeout(() => { intentPending = false; if (!pending) markBusy(false); }, 1800);
      }
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  window.addEventListener('submit', (event) => {
    if (!pending || !(event.target instanceof HTMLFormElement)) return;
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element && event.target.closest('cart-remove-button a');
    if (!link) return;
    setTimeout(() => {
      const error = document.querySelector('.cart-item__error-text');
      if (error && /line parameter is invalid/i.test(error.textContent || '')) window.location.reload();
    }, 1200);
  });
  nativeFetch(root() + 'cart.js').then((response) => response.json()).then(dropLonelyProtection).catch(() => {});
})();

